<template>
    <layout>
        <div class="w-100">
            <div class="row justify-content-center">
                <div class="col-10 col-sm-7 col-md-5 col-lg-8 col-xl-7 col-xxl-6 login-wrapper py-5">
                    <div class="mx-auto login-w-limit">
                        <div class="logo-wrapper text-center mb-2">
                            <img src="@/assets/img/bau-logo-for-light.svg" height="35"/>
                        </div>
                        <h4 class="text-center mb-5" style="min-height: 50px;">
                            {{ $t('fashion_design') }} {{ $t('application_system') }}
                        </h4>
                        <div class="fadeIn">
                            <ValidationObserver ref="form">
                                <div class="mx-auto">
                                    <ValidationProvider name="username" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('national_id')">
                                            <b-form-input type="text"
                                                          v-mask="'###########'"
                                                          v-model="loginForm.national_id"
                                                          :state="errors[0] ? false : null"/>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                    <ValidationProvider name="pin" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('pin')">
                                            <password-input
                                                v-model="loginForm.pin" :validateError="errors[0]"
                                                v-mask="'######'"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                    <div class="d-flex justify-content-center mb-4">
                                        <b-button variant="primary" block @click="login()">
                                            {{ $t('login').toUpper() }}
                                        </b-button>
                                    </div>
                                    <div class="d-flex justify-content-center mb-4">
                                        <b-button variant="outline-primary" block @click="goToRegister">
                                            {{ $t('sign_up') }}
                                        </b-button>
                                    </div>
                                    <div class="d-flex justify-content-center mb-4">
                                        <b-button variant="outline-secondary" block @click="$router.push('/fashion/design/application/forgot/password')">
                                            {{ $t('forgot_my_password') }}
                                        </b-button>
                                    </div>
                                </div>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>
                <div class="col-12 m-4 p-4 text-center">
                    {{ contactInfoText }}
                </div>
            </div>
            <vue-recaptcha ref="recaptcha" @verify="onCaptchaVerified" size="invisible"
                                        sitekey="6LcMe7IrAAAAANoOlSMkWztH9_KFU5Ofj7jUK7n7" />
        </div>
    </layout>
</template>

<script>
    // Layout
    import Layout from '@/modules/fashionDesignApplication/layout/Layout'

    // Component
    import PasswordInput from '@/components/elements/PasswordInput'

    // Service
    import FashionDesignService from "@/services/FashionDesignService";
    import ConstantService from "@/services/ConstantService";

    // Other
    import {ValidationObserver, ValidationProvider} from 'vee-validate'
    import { VueRecaptcha } from 'vue-recaptcha'
    import qs from "qs";

    export default {
        components: {
            PasswordInput,
            Layout,
            VueRecaptcha,
            ValidationObserver,
            ValidationProvider
        },
        metaInfo() {
            return {
                title: this.$t("fashion_design")+' '+this.$t('application_system'),
            };
        },
        data() {
            return {
                loginForm: {
                    national_id: null,
                    pin: null
                },
                contactInfoText: null,
            }
        },
        mounted() {
            this.$store.dispatch('fashionDesignApplication/initData');
            this.$store.dispatch('fashionDesignApplication/isLoginGoIndex');
            this.getContactInfo();
        },

      /*  created(){
            this.$swal
                .fire({
                    icon: 'info',
                    html: this.$t('conservatory_login_info'),
                    showCancelButton: false,
                    confirmButtonText: this.$t('ok'),
                })
        },*/

        methods: {
            getContactInfo() {
                const config = {
                    params: {
                        key: 'fashion_design_application.warning_message'
                    },
                    paramsSerializer: (params) => qs.stringify(params, { encode: false })
                };
                ConstantService.getValue(config)
                    .then(response => {
                        this.contactInfoText = response.data.data;
                    })
                    .catch(e => {
                        console.error("Error fetching data:", e);
                    });
            },
            onCaptchaVerified(recaptchaToken) {
                this.loginForm.g_recaptcha_token = recaptchaToken;
                FashionDesignService.login(this.loginForm).then(response => {
                    let data = response.data.data;

                    // Data
                    if (data) {
                        this.$store.commit('fashionDesignApplication/setData', data)
                    }
                    // National ID
                    if (this.loginForm.national_id) {
                        this.$store.commit('fashionDesignApplication/setNationalID', this.loginForm.national_id)
                    }
                    // Pin
                    if (this.loginForm.pin) {
                        this.$store.commit('fashionDesignApplication/setPin', this.loginForm.pin)
                    }
                    // TabIndex
                    let tab = -1
                    if(data.status == 'waiting_payment' && data.payment_status == 'E') {
                        tab = 3
                    } else if(data.status == 'waiting_payment' && data.payment_status == 'H') {
                        tab = 2
                    }else if(data.status == 'waiting') {
                        tab = 3
                    }
                    this.$store.commit('fashionDesignApplication/setTab', tab)
                    // Expire Time
                    this.$store.commit('fashionDesignApplication/setTime', new Date().getTime())
                }).then(() => {
                    this.$router.push('/fashion/design/application/form');
                }).catch((e) => {
                    this.showErrors(e);
                }).finally(() => {
                    this.$refs.recaptcha.reset()
                })
            },

            async login() {
                const isValid = await this.$refs.form.validate();
                if (isValid) {
                    this.$refs.recaptcha.execute()
                }
            },

            goToRegister() {
                this.$router.push('/fashion/design/application/register');
            }
        }
    }
</script>
